import {
  getLinks,
  AcceptedLinksStarts,
  StoryblokGetLinksResponse,
} from '@cinch-nx/data-storyblok'
import { GetStaticPathsResult } from 'next/types'

type Path = { params: { path: string[] } }

const convertStoryblokLinksToStaticPaths = ({
  links,
}: {
  links: StoryblokGetLinksResponse['links']
}) => {
  const paths: Path[] = []

  for (const linkKey of Object.keys(links)) {
    if (links[linkKey].is_folder || links[linkKey].is_startpage) {
      continue
    }

    const path = links[linkKey].slug.split('/')
    paths.push({ params: { path: path } })
  }

  return paths
}

export const getStaticPathsFromStoryblokSlugGenerator =
  (path: string) => async (): Promise<GetStaticPathsResult> => {
    try {
      const links = await getLinks(path as AcceptedLinksStarts)
      const paths = convertStoryblokLinksToStaticPaths({ links })
      return {
        paths: paths,
        fallback: 'blocking',
      }
    } catch {
      return {
        paths: [],
        fallback: 'blocking',
      }
    }
  }
